import { render, staticRenderFns } from "./ProjectShowButton.vue?vue&type=template&id=f1fb2058&scoped=true&"
import script from "./ProjectShowButton.vue?vue&type=script&lang=ts&"
export * from "./ProjectShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectShowButton.vue?vue&type=style&index=0&id=f1fb2058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb2058",
  null
  
)

export default component.exports